/*
  src/redux/auth/constants.js

  Created by Justin Chang on 5/16/2017.
*/

import { createConstant } from '../helpers';
const createConstantVariable = createConstant('auth');

// Set Constants
export const SET_AUTH_TOKEN = createConstantVariable('SET_AUTH_TOKEN');
export const SET_USER_ID    = createConstantVariable('SET_USER_ID');
export const SET_SESSION_ID    = createConstantVariable('SET_SESSION_ID');
export const INVALIDATE_ALL_AUTH = createConstantVariable('INVALIDATE_ALL_AUTH');

// Failure Constants
export const FAIL_TO_LOAD_ADJOY_TOKEN_FROM_COOKIES   = createConstantVariable('FAIL_TO_LOAD_ADJOY_TOKEN_FROM_COOKIES');
export const FAIL_TO_LOAD_ADJOY_USER_ID = createConstantVariable('FAIL_TO_LOAD_ADJOY_USER_ID');
export const FAIL_TO_SET_AUTH_TOKEN     = createConstantVariable('FAIL_TO_SET_AUTH_TOKEN');



// WEBPACK FOOTER //
// ./src/redux/auth/constants.js